import { post, get, del } from "./apiClient";

export function getProjectPage(params) {
  return post("/admin/dataSwapProject/getProjectPage", params);
}

export function getProjectDetail(id) {
  return get(`/admin/dataSwapProject/getProjectDetail/${id}`);
}

export function addProject(params) {
  return post("/admin/dataSwapProject/addProject", params);
}

export function editProject(params) {
  return post("/admin/dataSwapProject/editProject", params);
}

export function deleteProject(ids) {
  return del("/admin/dataSwapProject/delProject", { data: { ids } });
}